import React from "react";

const WeWorkRemotelyComponent = () => {
  return (
    <div>
      <h2>We Work Remotely</h2>
      <p>Discover remote job opportunities on We Work Remotely:</p>
      <a href="https://weworkremotely.com/">We Work Remotely - Remote Jobs</a>
      <p>
        We Work Remotely is a job board exclusively listing remote jobs across
        various job categories. Employers can post jobs specifically targeting
        remote workers, and job seekers can browse full-time, part-time, or
        freelance roles. The platform focuses solely on remote opportunities,
        making it easier for individuals looking for remote work arrangements.
      </p>
    </div>
  );
};

export default WeWorkRemotelyComponent;
